import * as React from 'react';
import { Form, Field } from 'react-final-form';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import validations from '../../../../lib/validation';
import { normalizePriceWithPrefix, maxValue } from '../../../../lib/helpers';
import TextField from '../../../utility/TextField';
import { buttonStyles } from '../../../../styles/base';

import style from '../../../../styles/sass/pages/Tools.module.scss';

export interface Props {
  calculatorSubmit: Function;
  classes: any;
  loaded: boolean;
  location: any;
  percentDownpayment: any;
  price: any;
}

const styles = {
  formCenter: {
    margin: '0 auto',
    maxWidth: 380,
    textAlign: 'center',
  },
  formField: {
    marginTop: 20,
  },
  lastFormField: {
    marginBottom: 50,
  },
  submitButton: {
    maxWidth: 275,
  },
};

export const ClosingCostsForm = (props: Props) => {
  const handleFormSubmit = (values: any) => {
    props.calculatorSubmit(values);
  };

  return (
    <Form
      onSubmit={handleFormSubmit}
      initialValues={{
        location: props.location,
        percentDownpayment: props.percentDownpayment,
        price: props.price,
      }}
      render={({ handleSubmit, values }) => (
        <form
          className={`${style.closingCostsForm} closing-costs-form  ${props.classes.formCenter}`}
        >
          <div className="column">
            <div
              className={`column form-column first ${props.classes.formField}`}
            >
              <Field
                name="price"
                type="text"
                component={TextField}
                format={normalizePriceWithPrefix}
                label="Home price"
                placeholder="$"
                autoComplete="off"
                validate={validations.required}
                fullWidth
              />
            </div>
            <div className={`column form-column ${props.classes.formField}`}>
              <Field
                name="percentDownpayment"
                type="text"
                component={TextField}
                label="Percent downpayment"
                placeholder="%"
                autoComplete="off"
                validate={validations.required}
                fullWidth
                parse={maxValue(100, '%')}
              />
            </div>
            {/* <div
              className={`column form-column ${props.classes.formField} ${props.classes.lastFormField}`}
            >
              <Field
                name="location"
                label="Location"
                component={DropDownSelect}
                selectKey
                options={locations}
                fullWidth
                validate={validations.required}
              />
            </div> */}
          </div>
          <Button
            variant="contained"
            // disabled={(values.price && values.price !== 'NaN') && values.percentDownpayment && values.location ? false : true}
            disabled={
              values.price &&
              values.price !== 'NaN' &&
              values.percentDownpayment
                ? false
                : true
            }
            className={`${props.classes.buttonMediumGreen} full-width ${props.classes.submitButton}`}
            type="submit"
            onClick={handleSubmit}
          >
            SUBMIT
          </Button>
        </form>
      )}
    />
  );
};

export default withStyles({ ...buttonStyles, ...styles })(ClosingCostsForm);
